(function () {
  if (window.__mpnMegaMenu) return; window.__mpnMegaMenu = true;
  var SEL = '.mpn-mm [data-mm-src]';
  function img(fam) { return fam ? fam.querySelector('.mpn-mm__frame--family .mpn-mm__img') : null; }
  function swap(a) {
    var fam = a.closest('.mpn-mm__family'), im = img(fam);
    if (!im) return;
    if (!im._mmOrig) im._mmOrig = { src: im.getAttribute('src'), srcset: im.getAttribute('srcset'), pos: im.style.objectPosition };
    im.removeAttribute('srcset');
    im.setAttribute('src', a.getAttribute('data-mm-src'));
    im.style.objectPosition = a.getAttribute('data-mm-pos') || 'center';
  }
  function restore(fam) {
    var im = img(fam);
    if (!im || !im._mmOrig) return;
    var o = im._mmOrig;
    if (o.srcset) im.setAttribute('srcset', o.srcset); else im.removeAttribute('srcset');
    if (o.src) im.setAttribute('src', o.src);
    im.style.objectPosition = o.pos;
    im._mmOrig = null;
  }
  /* Images de survol prechargees des l'ouverture du menu (affichage instantane au survol des liens) */
  function preload(d) {
    if (!d || d.__mmPre) return; d.__mmPre = true;
    d.querySelectorAll('[data-mm-src]').forEach(function (a) { var i = new Image(); i.decoding = 'async'; i.src = a.getAttribute('data-mm-src'); });
  }
  function warm(e) {
    var d = e.target.closest && e.target.closest('header-menu details.mpn-mm-details');
    if (d) preload(d);
  }
  document.addEventListener('mouseover', warm);
  document.addEventListener('focusin', warm);

  /* V19 : images principales du menu chargees AVANT l'ouverture (sinon cadres vides puis images qui arrivent).
     Declenche des que la souris entre dans l'en-tete, et a defaut quelques secondes apres le chargement de la page
     (ordinateur uniquement, quand le navigateur est au repos). */
  var mmWarm = false;
  function warmAll() {
    if (mmWarm) return; mmWarm = true;
    document.querySelectorAll('header-menu .mpn-mm img[loading="lazy"]').forEach(function (im) {
      im.decoding = 'async';
      im.setAttribute('loading', 'eager');
    });
    /* Vitesse (oct. 2026) : les images de survol des liens (1200 px) ne sont plus prechargees pour TOUS les menus a la fois :
       seulement pour le menu survole (fonction warm ci-dessus). */
  }
  function onHeaderEnter(e) {
    var t = e.target;
    if (t && t.closest && t.closest('.section-header, sticky-header, header, header-menu')) warmAll();
  }
  document.addEventListener('mouseover', onHeaderEnter, { passive: true });
  document.addEventListener('focusin', onHeaderEnter);
  /* Vitesse (oct. 2026) : plus de prechargement automatique 2,5 s apres le chargement de la page (toutes les images
     de tous les menus etaient telechargees meme si le visiteur n'ouvrait jamais le menu). Les images se chargent
     des que la souris entre dans l'en-tete (ou au clavier), donc toujours avant l'ouverture d'un menu. */

  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest(SEL);
    if (a) swap(a);
  });
  document.addEventListener('mouseout', function (e) {
    var a = e.target.closest && e.target.closest(SEL);
    if (!a) return;
    var to = e.relatedTarget, fam = a.closest('.mpn-mm__family');
    if (to && to.closest && to.closest(SEL) && to.closest('.mpn-mm__family') === fam) return;
    restore(fam);
  });
  document.addEventListener('focusin', function (e) {
    var a = e.target.closest && e.target.closest(SEL);
    if (a) swap(a);
  });
  document.addEventListener('focusout', function (e) {
    var a = e.target.closest && e.target.closest(SEL);
    if (!a) return;
    var fam = a.closest('.mpn-mm__family');
    setTimeout(function () {
      var f = document.activeElement;
      if (f && f.closest && f.closest(SEL) && f.closest('.mpn-mm__family') === fam) return;
      restore(fam);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var d = document.querySelector('header-menu details.mpn-mm-details[open]');
    if (!d) return;
    var s = d.querySelector('summary');
    var had = d.contains(document.activeElement);
    d.removeAttribute('open');
    if (s) { s.setAttribute('aria-expanded', 'false'); if (had) s.focus(); }
  });
})();
